import axios from 'axios'
import setConfig from '@/config/axios-config'
setConfig(axios)

const basePath = '/scan'
const axiosConfig = {
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
}
/**
 * 指定机构的扫描进度总览信息
 * @author wangk 2018-04-28T09:27:32+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const queryScanProgressSummary = (params = {}) => {
  return axios.post(basePath + '/queryScanProgressSummary', params)
    .then(res => res.data)
}

/**
 * 按机构的扫描监控
 * 查询当前机构的所有下级结构及其扫描总进度(扫描监控机构树图)
 * @author wangk 2018-04-27T18:42:53+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const queryScanProgressByOrgs = (params = {}) => {
  return axios.post(basePath + '/queryScanProgressByOrgs', params)
    .then(res => res.data)
}

/**
 * 查询指定机构的扫描进度详情
 * @author wangk 2018-04-27T18:42:35+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const queryScanProgressDetails = (params = {}) => {
  return axios.post(basePath + '/queryScanProgressDetails', params)
    .then(res => res.data)
}

/**
 * 查询当前机构下的所有学校扫描进度详情
 * @author wangk 2018-04-27T18:42:11+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const queryAllSchoolsScanProgress = (params = {}) => {
  return axios.post(basePath + '/queryAllSchoolsScanProgress', params)
    .then(res => res.data)
}

/**
 * 查询主观题识别考生数据
 * @author changh 2018-04-27T18:42:11+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const queryRecognitionInfo = (params = {}) => {
  return axios.post(basePath + '/queryRecognitionInfo', params)
    .then(res => res.data)
}
/**
 * 查询首页卡主观题识别进度，客观题识别，上传，扫描进度
 * @author changh 2018-04-27T18:42:11+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const queryRecognitionProgress = (params = {}) => {
  return axios.post(basePath + '/queryRecognitionProgress', params)
    .then(res => res.data)
}
/**
 * 获取识别结果
 * @author changh 2018-04-27T18:42:11+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const getScoreBatch = (params = {}) => {
  return axios.post(basePath + '/getScoreBatch', params)
    .then(res => res.data)
}
/**
 * 修改主观题识别结果
 * @author changh 2018-04-27T18:42:11+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const saveScoreBatch = (params = {}) => {
  return axios.post(basePath + '/saveScoreBatch', params)
    .then(res => res.data)
}
/**
 * 获取考生图像
 * @author changh 2018-04-27T18:42:11+0800
 * @param  {Object} params [description]
 * @return {[type]}        [description]
 */
const getImage = (params = {}) => {
  let json = JSON.stringify(params)
  return axios.post(`${basePath}/modelinfo.jsp`, `flag=GetImage&json=${json}`, axiosConfig)
    .then(res => res.data)
}
/**
 * 查询当前题目评卷教师信息。
 * 调用后台接口:modelinfo.jsp
 * @param {Object} param {"examId":"1572331475968","subjectId":"1571125089016","studentId":"9999999001","scanUrl":"http://10.117.1.227/scan/"}
 * @param {Object} [callback] 成功以后,执行回调函数
 * @return {TypeName} {"result":"true/false", "data":[], "desc":""}
 */
const AddReScanStudent = (param = {}) => {
  param.scanUrl = `${window.location.protocol}//${window.location.host}/scan/`
  let urlParams = 'flag=AddReScanStudent&json=' + JSON.stringify(param)
  return axios.post(`${basePath}/modelinfo.jsp`, urlParams, axiosConfig).then(res => res.data)
}
/**
 * 查询重扫考场
 * @author changh 2018-04-27T18:42:11+0800
 * @param  {Object} {
        'data': {
          'examId': '1520487556970',
          'subjectId': '1477722851901',
          'userOrgId': '123',
          },
        'pageSize': 20,
        'pageNum': 1
      } [description]
 * @return {[type]}        [description]
 */
const getReScanSchoolRoom = (params = {}) => {
  return axios.post(basePath + '/getReScanSchoolRoom', params)
    .then(res => res.data)
}
/**
 * 查询缺考考场
 * @author changh 2018-04-27T18:42:11+0800
 * @param  {Object} {
        'data': {
          'examId': '1520487556970',
          'subjectId': '1477722851901',
          'userOrgId': '123',
          },
        'pageSize': 20,
        'pageNum': 1
      } [description]
 * @return {[type]}        [description]
 */
const getShortCardSchoolRoom = (params = {}) => {
  return axios.post(basePath + '/getShortCardSchoolRoom', params)
    .then(res => res.data)
}
/**
 * 查询包含上传失败学生考场
 * @author chenxb 2020-09-28T18:42:11+0800
 * @param  {Object} {
        'data': {
          'examId': '1520487556970',
          'subjectId': '1477722851901',
          'userOrgId': '123',
          },
        'pageSize': 20,
        'pageNum': 1
      } [description]
 * @return {[type]}        [description]
 */
const getUploadFailSchoolRoom = (params = {}) => {
  return axios.post(basePath + '/getUploadFailSchoolRoom', params)
    .then(res => res.data)
}
/**
 * 查询未考考场
 * @author chenxb 2020-08-20T10:42:11+0800
 * @param  {Object} {
        'data': {
          'examId': '1520487556970',
          'subjectId': '1477722851901',
          'userOrgId': '123',
          },
        'pageSize': 20,
        'pageNum': 1
      } [description]
 * @return {[type]}        [description]
 */
const getNeverScanSchoolRoom = (params = {}) => {
  return axios.post(basePath + '/getNeverScanSchoolRoom', params)
    .then(res => res.data)
}
/**
 * 查询重扫名单
 * @author changh 2018-04-27T18:42:11+0800
 * @param  {Object} {
    'data': {
      'examId': '1520487556970',
      'subjectId': '1477722851901',
      'userOrgId': '123', //用户所属机构,与schoolId二选一
      'schoolId': '123',
      'room': '1', //选填
      'rescaned': '1' //1,已重扫；0,未重扫;选填
      },
    'pageSize': 20,
    'pageNum': 1
  } [description]
 * @return {[type]}        [description]
 */
const getReScanStudent = (params = {}) => {
  return axios.post(basePath + '/getReScanStudent', params)
    .then(res => res.data)
}
/**
 * 查询上传失败名单
 * @author chenxb 2020-09-28T18:42:11+0800
 * @param  {Object} {
    'data': {
      'examId': '1520487556970',
      'subjectId': '1477722851901',
      'userOrgId': '123', //用户所属机构,与schoolId二选一
      'schoolId': '123',
      'room': '1', //选填
      'studentId': '1' //准考证号
      },
    'pageSize': 20,
    'pageNum': 1
  } [description]
 * @return {[type]}        [description]
 */
const getUploadFailStudent = (params = {}) => {
  return axios.post(basePath + '/getUploadFailStudent', params)
    .then(res => res.data)
}
/**
 * 查询未上传名单
 * @author changh 2020-09-28T18:42:11+0800
 * @param  {Object} {
    'data': {
      'examId': '1520487556970',
      'subjectId': '1477722851901',
      'userOrgId': '123', //用户所属机构,与schoolId二选一
      'schoolId': '123',
      'room': '1', //选填
      'studentId': '1' //准考证号
      mac: '',  // 选填
      type: '' //0：未上传+上传失败，1：未上传，2：上传失败
      },
    'pageSize': 20,
    'pageNum': 1
  } [description]
 * @return {[type]}        [description]
 */
const getNotUploadStudent = (params = {}) => {
  return axios.post(basePath + '/getNotUploadStudent', params)
    .then(res => res.data)
}

/**
 * 导出重扫名单
 * @author changh 2018-04-27T18:42:11+0800
 * @param  {Object} {
    'data': {
      'examId': '1520487556970',
      'subjectId': '1477722851901',
      'userOrgId': '123' //用户所属机构，orgId或schoolId
      },
    'pageSize': 20,
    'pageNum': 1
  } [description]
 * @return {[type]}        [description]
 */
const exportReScanStudent = (params = {}) => {
  return axios.post(basePath + '/exportReScanStudent', params)
    .then(res => res.data)
}
/**
 * 查询未扫名单
 * @author chenxb 2020-08-20T10:42:11+0800
 * @param  {Object} {
    'data': {
      'examId': '1520487556970',
      'subjectId': '1477722851901',
      'userOrgId': '123', //用户所属机构,与schoolId二选一
      'schoolId': '123',
      'room': '1', //选填
      'studentId': '1' //准考证号
      },
    'pageSize': 20,
    'pageNum': 1
  } [description]
 * @return {[type]}        [description]
 */
const getShortCardStudent = (params = {}) => {
  return axios.post(basePath + '/getShortCardStudent', params)
    .then(res => res.data)
}
/**
 * 查询未扫名单
 * @author changh 2018-04-27T18:42:11+0800
 * @param  {Object} {
    'data': {
      'examId': '1520487556970',
      'subjectId': '1477722851901',
      'userOrgId': '123', //用户所属机构,与schoolId二选一
      'schoolId': '123',
      'room': '1', //选填
      'studentId': '1' //准考证号
      },
    'pageSize': 20,
    'pageNum': 1
  } [description]
 * @return {[type]}        [description]
 */
const getNeverScanStudent = (params = {}) => {
  return axios.post(basePath + '/getNeverScanStudent', params)
    .then(res => res.data)
}
/**
 * 导出未扫描考生
 * @author changh 2021-05-17T11:12:02+0800
 * @param
  {
		'data': {
			examId: '',
			subjectId: '',
      userOrgId: ''
		}
	} [description]
 * @return {[type]}        [description]
 */
const exportNeverScanStudent = (params = {}) => {
  return axios.post(basePath + '/exportNeverScanStudent', params).then(res => res.data)
}
/**
 * 查询缺卡名单
 * @author changh 2018-04-27T18:42:11+0800
 * @param  {Object} {
    'data': {
      'examId': '1520487556970',
      'subjectId': '1477722851901',
      'userOrgId': '123' //用户所属机构，orgId或schoolId
      },
    'pageSize': 20,
    'pageNum': 1
  } [description]
 * @return {[type]}        [description]
 */
const exportShortCardStudent = (params = {}) => {
  return axios.post(basePath + '/exportShortCardStudent', params)
    .then(res => res.data)
}
/**
 * 导出上传失败名单
 * @author chenxb 2020-09-28T18:42:11+0800
 * @param  {Object} {
    'data': {
      'examId': '1520487556970',
      'subjectId': '1477722851901',
      'userOrgId': '123' //用户所属机构，orgId或schoolId
      },
    'pageSize': 20,
    'pageNum': 1
  } [description]
 * @return {[type]}        [description]
 */
const exportUploadFailStudent = (params = {}) => {
  return axios.post(basePath + '/exportUploadFailStudent', params)
    .then(res => res.data)
}
/**
 * 导出未上传名单
 * @author changh 2021-09-28T18:42:11+0800
 * @param  {Object} {
    'data': {
      'examId': '1520487556970',
      'subjectId': '1477722851901',
      'userOrgId': '123' //用户所属机构，orgId或schoolId
       type: '' //0：未上传+上传失败，1：未上传，2：上传失败
      },
    'pageSize': 20,
    'pageNum': 1
  } [description]
 * @return {[type]}        [description]
 */
const exportNotUploadStudent = (params = {}) => {
  return axios.post(basePath + '/exportNotUploadStudent', params)
    .then(res => res.data)
}
/**
 * 检查采集软件是否安装
 * @author changh 2018-04-27T18:42:11+0800
 * @param ...
 * @return {[type]}        [description]
 */
const checkScanSoft = (params = {}) => {
  return axios.get('http://localhost:10003/software')
    .then(res => res.data)
}

/**
 * 清理扫描数据
 * @author maiyikai 2020-05-19T10:20:02+0800
 * @param  {Object} params { examId: '', subjectId: '', mobilePhone: '', verifySmsCode: '', organizationIdList: [], onlyCleanRecognition: false }
 * @return {Promise}
 *         data  {
 *                 result: 'true'
 *               }
 */
const cleanScanData = (params = {}) => {
  return axios.post(basePath + '/cleanScanData', params, {
    timeout: 5 * 60 * 1000
  }).then(res => res.data)
}
/**
 * 清理考生OMR数据
 * @author chenxb 2025-01-14T15:28:19+0800
 * @param  {Object} params { examId: '', subjectId: '', studentIds: '' }
 * @return {Promise}
 *         data  {
 *                 result: 'true'
 *               }
 */
const cleanOmrData = (params = {}) => {
  return axios.post(basePath + '/resetByStudents', params).then(res => res.data)
}
/**
 * 获取学生Omr信,息
 * @author chenxb 2024-07-17T11:22:49+0800
 * @param  {Object} {
    'examId': '1520487556970',
    'subjectId': '1477722851901',
    'studentId': '123'
  [description]
 * @return {[type]}        [description]
 */
const getStudentOmrInfo = (params = {}) => {
  let json = window.btoa(JSON.stringify(params))
  return axios.post(`${basePath}/omrInfo.jsp`, `flag=getStudentOmrInfo&json=${json}`, axiosConfig)
    .then(res => res.data)
}

export {
  queryScanProgressSummary,
  queryScanProgressByOrgs,
  queryScanProgressDetails,
  queryAllSchoolsScanProgress,
  queryRecognitionInfo,
  queryRecognitionProgress,
  getScoreBatch,
  saveScoreBatch,
  getImage,
  AddReScanStudent,
  getReScanSchoolRoom,
  getShortCardSchoolRoom,
  getUploadFailSchoolRoom,
  getNeverScanSchoolRoom,
  getReScanStudent,
  getUploadFailStudent,
  getNotUploadStudent,
  exportReScanStudent,
  getShortCardStudent,
  getNeverScanStudent,
  exportShortCardStudent,
  exportUploadFailStudent,
  exportNotUploadStudent,
  exportNeverScanStudent,
  checkScanSoft,
  cleanScanData,
  cleanOmrData,
  getStudentOmrInfo
}



// WEBPACK FOOTER //
// ./src/model/monitor-scan-model.js